import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { UserGuard } from './guards/user.guard';
import { AdminGuard } from './guards/admin.guard';
import { PublisherGuard } from './guards/publisher.guard';
import { AllGuard } from './guards/all.guard';
import { PublisherListComponent } from './publisherList/publisher.list.component';
import { UserListComponent } from './userList/user.list.component';
import { PublisherDetailComponent} from './publisherDetail/publisher.detail.component';
import { UserDetailComponent } from './userDetail/user.detail.component';
import { UserNewComponent } from './userNew/user.new.component';
import { UserUpdateComponent } from './userUpdate/user.update.component';
import { PublisherNewComponent } from './publisherNew/publisher.new.component';
import { PublisherUpdateComponent } from './publisherUpdate/publisher.update.component';
import { MediaNewComponent } from './mediaNew/media.new.component';
import { MediaUpdateComponent } from './mediaUpdate/media.update.component';
import { MediaDetailComponent } from './mediaDetail/media.detail.component';
import { VersionDetailComponent } from './versionDetail/version.detail.component';
import { VersionNewComponent } from './versionNew/version.new.component';
import { LogListComponent } from './log/log.list.component';
import { UserStatComponent } from './userStat/user.stat.component';
import { MediaStatComponent } from './mediaStat/media.stat.component';
import { MediaUploadComponent } from './mediaUpload/media.upload.component';
import { GridComponent } from './grid/grid.component';
import { SoftwareComponent } from './software/software.component';
import { StreamingComponent } from './streaming/streaming.component';
import { BlacklistComponent } from './blacklist/blacklist.component';

export const routes = [
  { path: '', component: LoginComponent },
  { path: 'user/list', component: UserListComponent, canActivate: [AdminGuard] },
  { path: 'user/detail/:id', component: UserDetailComponent, canActivate: [AllGuard] },
  { path: 'user/new/:id', component: UserNewComponent, canActivate: [PublisherGuard] },
  { path: 'user/update/:userId', component: UserUpdateComponent, canActivate: [AllGuard] },
  { path: 'publisher/list', component: PublisherListComponent, canActivate: [AdminGuard] },
  { path: 'publisher/detail/:id', component: PublisherDetailComponent, canActivate: [AllGuard] },
  { path: 'publisher/new', component: PublisherNewComponent, canActivate: [AdminGuard] },
  { path: 'publisher/update/:publisherId', component: PublisherUpdateComponent, canActivate: [PublisherGuard] },
  { path: 'media/detail/:id', component: MediaDetailComponent, canActivate: [AllGuard] },
  { path: 'media/new/:id', component: MediaNewComponent, canActivate: [PublisherGuard] },
  { path: 'media/update/:mediaId', component: MediaUpdateComponent, canActivate: [PublisherGuard] },
  { path: 'version/detail/:id', component: VersionDetailComponent, canActivate: [AllGuard] },
  { path: 'version/new/:id', component: VersionNewComponent, canActivate: [AllGuard] },
  { path: 'log/list/:publisherId', component: LogListComponent, canActivate: [PublisherGuard] },
  { path: 'user/:userId/stats', component: UserStatComponent, canActivate: [AdminGuard] },
  { path: 'media/:mediaId/stats', component: MediaStatComponent, canActivate: [PublisherGuard] },
  { path: 'media/upload/:mediaId', component: MediaUploadComponent, canActivate: [AllGuard] },
  { path: 'grid', component: GridComponent, canActivate: [AllGuard]},
  { path: 'software', component: SoftwareComponent, canActivate: [AdminGuard] },
  { path: 'streaming', component: StreamingComponent, canActivate: [AdminGuard] },
  { path: 'blacklist', component: BlacklistComponent, canActivate: [AdminGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }




// WEBPACK FOOTER //
// ./src/app/app.routes.ts